<template>
  <div class="blog">
      <Loader v-if="loader == true"  />
      <div 
            v-else
            class="main_block_loader"
       >
        <div class="blog_header">
            <h1>{{name}}</h1>
        </div>
        <div class="blog_content">
            <!-- content blog -->
            <div id="blog_content_view">

            </div>
        </div>
      </div>
      
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'blogs',
  components: {
      Loader
  },
  data () {
      return {
        id: this.$route.params.id,
        name: '',
        loader: true
      }
  },
  methods: {
     getBlog() {
        fetch(this.$apiURI + 'public/blogs/get?data={"id": "' + this.id + '"}')
        .then((res) => {
            if (res) {
                this.loader = false
                res.json().then((data) => {
                    this.name = data[0].name
                    let block_content = document.getElementById('blog_content_view')
                    block_content.innerHTML = data[0].html
                });
            }
        })
    },
  },
  mounted() {
      this.getBlog()
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.blog {
    width: 1200px;
    margin: 0 auto;
    background: white;
    overflow: hidden;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .main_block_loader {
        width: 100%;
        .blog_header {
            padding-top: 20px;
            padding-bottom: 20px;
            text-align: center;
            h1 {
                font-size: 30px;
                @media (max-width: @baseMedia) {
                    font-size: 18px;
                }
            }
        }
        .blog_content {
            width: 97%;
            margin: 0 auto;
            padding: 10px;
            border: 2px dotted #ccc;
            margin-bottom: 10px;
            @media (max-width: @baseMedia) {
                    font-size: 15px;
            }
        }
    }
}
</style>